// splide
function initSplideMediasUgc() {
	const splideElemMedia = document.querySelector(".mm-media-ugc-splide");
	if (splideElemMedia) {
		if (splideElemMedia.splideInstance) {
			splideElemMedia.splideInstance.destroy(true);
		}
		const splideInstance = new Splide(splideElemMedia, {
			type: "slide",
			perPage: 3,
			gap: "16px",
			arrows: true,
			omitEnd: true,
			pagination: false,
			padding: { right: "72px" },
			breakpoints: {
				1024: {
					perPage: 2,
					gap: "16px",
				},
				768: {
					perPage: 1,
				},
			},
		}).mount();
		splideElemMedia.splideInstance = splideInstance;
		splideElemMedia.classList.add("is-initialized");
	}
}

function closeVideoOverlay() {
	const section = document.querySelector(".mm-section-medias-container");
	if (section) section.classList.remove("overlay-active");
	document.querySelectorAll(".mm-video-ugc").forEach((el) => el.classList.remove("active"));
	document.querySelectorAll(".mm-wrapper-media-ugc-bloc").forEach((bloc) => bloc.classList.remove("dimmed"));
	document.body.classList.remove("stop-scrolling");
}

function openVideoOverlay() {
	const section = document.querySelector(".mm-section-medias-container");
	if (section) section.classList.add("overlay-active");
}

function updateVideoProgress(video) {
	const container = video.closest(".mm-video-ugc");
	const bar = container?.querySelector(".mm-media-time-line-fill");
	if (!bar || !video.duration) return;
	const update = () => {
		const progress = (video.currentTime / video.duration) * 100;
		bar.style.width = `${progress}%`;
		if (!video.paused && !video.ended) {
			requestAnimationFrame(update);
		}
	};
	update();
}

function initMedias() {
	// Initialisation Splide
	initSplideMediasUgc();

	// Mute toutes les vidéos et applique l'icône
	document.querySelectorAll(".mm-video-ugc").forEach((videoContainer) => {
		const videos = videoContainer.querySelectorAll("video");
		const toggleWrapper = videoContainer.querySelector(".mm-icon-sound-toggle");
		if (videos.length > 0 && toggleWrapper) {
			// On mute toutes les vidéos (desktop et mobile)
			videos.forEach((video) => {
				video.muted = true;
			});
			toggleWrapper.classList.toggle("is-muted", true);
		}
	});

	// Progress bar video
	document.querySelectorAll(".mm-video-ugc video").forEach((video) => {
		video.addEventListener("play", () => updateVideoProgress(video));
		video.addEventListener("ended", () => {
			const container = video.closest(".mm-video-ugc");
			const bar = container?.querySelector(".mm-media-time-line-fill");
			if (bar) bar.style.width = "0%";
		});
		video.addEventListener("loadedmetadata", () => updateVideoProgress(video));
	});
}

document.addEventListener("DOMContentLoaded", function () {
	initMedias();

	document.body.addEventListener("click", function (e) {
		// Ouvre une vidéo UGC
		const preview = e.target.closest(".mm-media-preview");
		if (preview) {
			const index = preview.dataset.index;
			const videoBloc = document.querySelector(`.mm-video-ugc[data-index="${index}"]`);
			const video = videoBloc?.querySelector("video");

			// Vérifie si la vidéo existe
			if (videoBloc && video) {
				document.querySelectorAll(".mm-video-ugc").forEach((el) => el.classList.remove("active"));
				videoBloc.classList.add("active");
				document.querySelectorAll(".mm-wrapper-media-ugc-bloc").forEach((bloc) => bloc.classList.add("dimmed"));
				document.body.classList.add("stop-scrolling");
				openVideoOverlay();
			}
			return;
		}

		// Ferme la vidéo (croix)
		if (e.target.closest(".mm-icon-close")) {
			closeVideoOverlay();
			return;
		}

		// Ferme la vidéo si clic sur l'overlay (.mm-section-medias-container:after)
		const section = document.querySelector(".mm-section-medias-container");
		const videoActive = document.querySelector(".mm-video-ugc.active");
		if (section && section.classList.contains("overlay-active") && e.target === section && videoActive) {
			closeVideoOverlay();
			return;
		}

		// Toggle mute/unmute
		const toggleWrapper = e.target.closest(".mm-icon-sound-toggle");
		if (toggleWrapper) {
			const videoContainer = toggleWrapper.closest(".mm-video-ugc");
			const videos = videoContainer?.querySelectorAll("video");
			if (videos && videos.length > 0) {
				// On change l'état du son pour toutes les vidéos
				const newMutedState = !videos[0].muted;
				videos.forEach((video) => {
					video.muted = newMutedState;
					if (!newMutedState && video.paused) {
						video.play();
					}
				});
				toggleWrapper.classList.toggle("is-muted", newMutedState);
			}
			return;
		}

		// Toggle overlay info produit
		const infoToggle = e.target.closest(".mm-wrapper-video-ugc-info");
		if (infoToggle) {
			const videoWrapper = infoToggle.closest(".mm-video-ugc");
			const overlay = videoWrapper?.querySelector(".mm-video-gradient-overlay");
			infoToggle.classList.toggle("is-open");
			if (overlay) {
				overlay.classList.toggle("mm-none", !infoToggle.classList.contains("is-open"));
			}
			return;
		}
	});
});
